export default "__VITE_ASSET__Cvrubj$Y__"